import { RowDataGames } from "../../components/GamesFPSPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the GamesTable factory
 */
class GamesRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/games/read-range"
        this.accessData = "games"
    }

    create(games: any): RowDataGames {
        const rowDataOrder: RowDataGames = {
            id: games.id,
    
            name: games.name,

            img: games.img,
            
            show: games.show,
        
            createdAt: games.createdAt,
            updatedAt: games.updatedAt,
            action: "",
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let gamesRow: GamesRow | null = null;

export default function getGamesRow(): GamesRow {
    if (gamesRow === null)
        gamesRow = new GamesRow()
    return gamesRow
}